const getMaxWidthString = width => `(max-width:${width - 1}px)`;

const getMinWidthString = width => `(min-width:${width}px)`;

const getMediaQueryString = (minBreakpoint, maxBreakpoint) => (
  minBreakpoint && maxBreakpoint ? (
    `${getMinWidthString(minBreakpoint.width)} and ${getMaxWidthString(maxBreakpoint.width)}`
  ) : (
    getMinWidthString(minBreakpoint.width)
  )
);

const getBreakpointNames = (breakpoints, breakpointNames) => breakpointNames || Object.keys(breakpoints);

export const getBreakpoints = (breakpoints = {}, breakpointNames) => (
  getBreakpointNames(breakpoints, breakpointNames)
    .map(name => ({
      name,
      width: parseInt(breakpoints[name], 10),
    }))
    .filter(({ width }) => !Number.isNaN(width))
    .sort((a, b) => a.width - b.width)
    .map(({ name }, index, array) => ({
      name,
      mediaQueryString: getMediaQueryString(array[index], array[index + 1]),
    }))
);

export const isMobileBreakpoint = ({ name, isMobileConditionBreakpointsArray }) =>
  (isMobileConditionBreakpointsArray || ['xsmall', 'small', 'medium']).includes(name);
